import { Component, OnInit } from '@angular/core';

 /**
  * Loader Component.
  */
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
  standalone: false
})
export class LoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
